import { ArrayMaxSize, ArrayNotEmpty, IsArray, IsNotEmpty, IsString, Length } from 'class-validator';

const ORDER_LIMIT_PER_ACCOUNT = 10;
const MIN_ORDER_NUMBER_LENGTH = 11; // Sales order created directly in Dynamics
const MAX_ORDER_NUMBER_LENGTH = 13; // Sales order created through Backstage
const SF_ACCOUNT_ID_LENGTH = 18;

/**
 * DTO that represents the accounts to which the orders should be copied/duplicated
 */
export class OrderCopyTargetDto {
  /**
   * Order numbers of the orders to be copied to the target account. It should be sales or draft order numbers
   * @example ["SO01B0041950U", "DRAFT-163938"]
   */
  @IsArray()
  @ArrayNotEmpty()
  @ArrayMaxSize(ORDER_LIMIT_PER_ACCOUNT)
  @Length(MIN_ORDER_NUMBER_LENGTH, MAX_ORDER_NUMBER_LENGTH, { each: true })
  public orderNumbers: string[];

  /**
   * Salesforce account ID of the account to which the orders are to be copied
   * @example 0015I00000JUmsgQADuu
   */
  @IsNotEmpty()
  @IsString()
  @Length(SF_ACCOUNT_ID_LENGTH, SF_ACCOUNT_ID_LENGTH)
  public accountId: string;
}
